import {useEffect} from 'react';

export const RenderMetaPixel = (props) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = '//js.hs-scripts.com/6438710.js';
    script.async = true;
    script.id = 'hs-script-loader';
    script.type = 'text/javascript';
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    window.fbq('track', 'PageView');
  }, []);

  useEffect(() => {
    ttq.load('CGTMBP3C77UD71N1K670');
    ttq.page();
  }, []);
  
};
